class VideoStream {

    constructor(videoElement) {
        this.videoElement = videoElement;

        if (Hls.isSupported()) {
            this.loadHlsStream();
        } else if (this.videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            this.loadNativeHlsStream();
        } else {
            this.showFallbackError();
        }
    }

    loadHlsStream() {
        this.hls = new Hls();
        this.hls.loadSource(this.videoElement.dataset.src);
        this.hls.attachMedia(this.videoElement);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            this.videoElement.parentNode.classList.add("videostream--loaded");
        });

        // Error handling
        this.hls.on(Hls.Events.ERROR, (event, data) => {
            if (data.fatal) {
                switch (data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                        // try to recover network error
                        console.log("fatal network error encountered, try to recover");
                        this.hls.startLoad();
                        break;
                    case Hls.ErrorTypes.MEDIA_ERROR:
                        console.log("fatal media error encountered, try to recover");
                        this.hls.recoverMediaError();
                        break;
                    default:
                        // cannot recover
                        this.showFallbackError();
                        this.hls.destroy();
                        break;
                }
            }
        });
    }

    loadNativeHlsStream() {
        this.videoElement.src = this.videoElement.dataset.src;
        this.videoElement.addEventListener('loadedmetadata', () => {
            this.videoElement.parentNode.classList.add("videostream--loaded");
        });
    }

    showFallbackError() {
        this.videoElement.parentNode.classList.add("videostream--error");
        this.videoElement.parentNode.innerHTML = "<div class='videostream__text'>Video could not be loaded</div>";
    }
}

function initialize() {
    console.log('initialize');
    return [...document.querySelectorAll("[data-videostream]")]
        .map((element) => {
            return new VideoStream(element);
        });
}

initialize();
